import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const TABLE_ALL_OPEN_TASK = 'allOpenTask'

export const TABLE_PROCESS_WORKLIST = 'ProcessWorklist'

export const FIND_TASK_LIST_REQUEST = NS + 'FIND_TASK_LIST_REQUEST'
export const FIND_TASK_LIST_SUCCESS = NS + 'FIND_TASK_LIST_SUCCESS'
export const FIND_TASK_LIST_ERROR = NS + 'FIND_TASK_LIST_ERROR'

export const CHANGE_TABLE_SETTING = NS + 'CHANGE_TABLE_SETTING'

export const CHANGE_ALL_OPEN_TABLE_SETTING = NS + 'CHANGE_ALL_OPEN_TABLE_SETTING'

export const FIND_ALL_OPEN_TASK_LIST_REQUEST = NS + 'FIND_ALL_OPEN_TASK_LIST_REQUEST'
export const FIND_ALL_OPEN_TASK_LIST_SUCCESS = NS + 'FIND_ALL_OPEN_TASK_LIST_SUCCESS'
export const FIND_ALL_OPEN_TASK_LIST_ERROR = NS + 'FIND_ALL_OPEN_TASK_LIST_ERROR'



// WEBPACK FOOTER //
// ./src/modules/process/state/task-list/type.js